import { createIcon } from '@chakra-ui/react';

export const CreditCard = createIcon({
  displayName: 'Credit Card',
  viewBox: '0 0 32 20.531',
  path: (
    <path
      id="Payment_Card_General_2"
      data-name="Payment Card General "
      d="M4.269,28.811h6.425a.762.762,0,1,0,0-1.524H4.269a.762.762,0,0,0,0,1.524Zm0-3.464H19.878a.762.762,0,0,0,0-1.524H4.269a.762.762,0,0,0,0,1.524ZM28.091,11.79H4.909A4.409,4.409,0,0,0,.5,16.2V27.912a4.409,4.409,0,0,0,4.409,4.409H28.091A4.409,4.409,0,0,0,32.5,27.912V16.2a4.409,4.409,0,0,0-4.409-4.409Zm2.9,16.122a2.9,2.9,0,0,1-2.9,2.9H4.909a2.9,2.9,0,0,1-2.9-2.9V20.72H30.966Zm0-11.54H2.034V16.2a2.9,2.9,0,0,1,2.9-2.9H28.091a2.9,2.9,0,0,1,2.9,2.9Z"
      transform="translate(-0.5 -11.79)"
      fill="currentColor"
    />
  ),
});
